import { useRef } from "react";
import { motion, useMotionValue, useSpring, useReducedMotion } from "framer-motion";
import { MOTION, isFinePointer } from "./config";

export function Magnetic({ children, className = "", max = MOTION.magnetic.max, ...rest }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const mx = useMotionValue(0), my = useMotionValue(0);
  const x = useSpring(mx, { stiffness: 220, damping: 18, mass: 0.6 });
  const y = useSpring(my, { stiffness: 220, damping: 18, mass: 0.6 });
  const active = !reduced && isFinePointer();

  const onMove = (e) => {
    if (!active || !ref.current) return;
    const b = ref.current.getBoundingClientRect();
    const dx = e.clientX - (b.left + b.width / 2), dy = e.clientY - (b.top + b.height / 2);
    const clamp = (v) => Math.max(-max, Math.min(max, v * MOTION.magnetic.strength));
    mx.set(clamp(dx)); my.set(clamp(dy));
  };
  const reset = () => { mx.set(0); my.set(0); };

  return <motion.div ref={ref} style={{ x, y, display: "inline-block" }} className={className} onMouseMove={onMove} onMouseLeave={reset} {...rest}>{children}</motion.div>;
}
